import React from 'react'
import { useLocation } from 'react-router-dom'
import TemplateBuilder from '../../components/whatsapp/TemplateBuilder'

export default function CreateTemplate() {
  const location = useLocation()
  const data = location.state
  return (<TemplateBuilder template={data?.sample} config={data?.config} />)
}
